export default {
  '-2000': '未登录',
  '-2001': '参数错误',
  '-2002': '保存数据失败',
  '-2003': '修改数据失败',
  '-2004': '获取数据失败',
  '-2005': 'ID 不能为空',
  '-2006': '数据已经存在',
  '-2007': '数据不存在',
  '-2008': '邮箱非法',
  '-2009': '回复不存在',
  '-2010': '非法的状态',
  '-2011': 'JSON 数据错误',
  '-2012': '导航数据错误',
  '-2013': '类型错误',
  '-2014': '包含敏感词，请重新输入',
  '-4002': '图形验证码错误',
  '-4003': '图形验证码错误',
  '-4004': '图形验证码错误'
}

export const draftErrorCode = {
  '-12000': '未登录',
  '-12001': '参数错误',
  '-12002': '数据不存在',
  '-12003': '系统错误',
  '-12004': '您还不是作者',
  '-12005': '草稿数量上限',
  '-12008': '草稿错误',
  '-12009': '草稿字数异常',
  '-12010': '草稿已发布无法继续更新',
  '-12011': '文章发布失败',
  '-12012': '文章下线失败',
  '-12013': '文件上传失败',
  '-7000': '数据解析失败',
  '-7001': '参数错误',
  '-7002': '系统错误',
  '-7003': 'id不存在',
  '-7004': '不是最新版本',
  '-7005': '版本差异较大',
  '-7006': '增量内容相同'
}

export const signin = {
  cellphone: {
    '-2001': '发送失败,请重试',
    '-3010': '非法电话',
    '-3011': '该账号不存在或密码错误', // 账号不存在
    '-3012': '该手机号已注册',
    '-3019': '该手机号已被使用',
    '-3040': '重新输入用户基本信息'
  },
  email: {
    '-3000': '操作过于频繁，请稍后重试',
    '-3015': '邮箱格式错误',
    '-3016': '邮箱不在认领列表或已被认领',
    '-3017': '邮箱已注册'
  },
  password: {
    '-3030': '密码格式错误，6到16位字符',
    '-3031': '密码错误',
    '-3033': '新旧密码一致',
    '-3040': '验证已过期'
  },
  newpassword: {
    '-3032': '密码格式错误，6到16位字符'
  },
  code: {
    '-3000': '操作过于频繁，请稍后重试',
    '-3001': '验证码已失效，请重新获取',
    '-3002': '验证码格式错误',
    '-3003': '验证码错误',
    '-3007': '短信验证码已失效，请重新获取',
    '-3008': '非法短信验证码',
    '-3009': '短信验证码不正确'
  },
  captcha: {
    '-3004': '图形验证码错误',
    '-3005': '图形验证码错误',
    '-3006': '图形验证码错误'
  }
}
